import { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {


  const transitionStyle =
    "transition ease-in delay-75 hover:-translate-x-1 hover:scale-95 duration-150 ";
  return (
    <div className="py-4 px-40 flex justify-between  items-center  shadow-2xl  bg-slate-900 sticky top-0">
      <div className="text-start">
        <h1 className="text-4xl">{"<Hrithik/>"}</h1>
      </div>

      <ul className="flex text-xl gap-5 items-center">
        {/* <li className={transitionStyle}>Intro</li>
        <li className={transitionStyle}>Projects</li>
        <li className={transitionStyle}>Skills&Tools</li>
        <li className={transitionStyle}>Contact</li> */}

        
        <li className=" text-xl px-2 flex items-center justify-center text-[#101d42] bg-neutral-100 border-2 rounded-full  hover:bg-[#101d42] hover:text-neutral-100 ">
          {/* <img src="https://img.icons8.com/windows/24/download--v1.png" className="text-violet-200" /> */}
          <a href="https://drive.google.com/file/d/1vkgaWCax4m4kbESJEkREEBPkA6LW0G7y/view?usp=sharing" target="_blank">          <button>Resume</button>
</a>
        </li>
      </ul>
    </div>
  );
};

export default Header;
